export const onDialogClose = dialogType => ({
  widget: 'models',
  type: 'onDialogClose',
  payload: { dialogType },
})



// WEBPACK FOOTER //
// ./src/models/actions/onDialogClose.js